const SandboxBanner = () => (
  <div className="fixed inset-x-0 top-0 z-20 flex h-15 items-center justify-start gap-3 bg-cofeeYellow3 px-6 text-cofeeNeutral10">
    <div className="rounded-md bg-cofeeYellow6 px-6 py-1.5 font-bold text-cofeeNeutral10">
      TEST MODE
    </div>
    <span className="text-base font-medium text-cofeeNeutral10">
      You are currently in test mode. Transactions made in this environment are
      for testing purposes only
    </span>
  </div>
);

export default SandboxBanner;
